import { type FC, type ReactNode } from 'react';

import styles from './SEOBlockLayout.css';

type SEOBlockLayoutProps = {
  averagePrice: ReactNode;
  header: ReactNode;
  quickLinks: ReactNode;
};

export const SEOBlockLayout: FC<SEOBlockLayoutProps> = props => {
  const { header, quickLinks, averagePrice } = props;

  return (
    <section className={styles['container']}>
      <div className={styles['header']}>{header}</div>
      <div className={styles['content']}>
        <div className={styles['average-price']}>{averagePrice}</div>
        <div className={styles['quick-links']}>{quickLinks}</div>
      </div>
    </section>
  );
};
